function createArrayOfNumber(length) {
  return new Array(length + 1).fill(length).map((val, index) => index / length);
}
function withIntersectionObserver(BaseClass, defaultOptions = { threshold: createArrayOfNumber(100) }) {
  class WithIntersectionObserver extends BaseClass {
    /**
     * Config
     */
    static config = {
      ...BaseClass.config,
      name: `${BaseClass.config.name}WithIntersectionObserver`,
      options: {
        ...BaseClass.config?.options || {},
        intersectionObserver: Object
      },
      emits: ["intersected"]
    };
    /**
     * Intersection observer instance.
     */
    $observer;
    /**
     * Create an observer when the class in instantiated.
     */
    constructor(element) {
      super(element);
      this.$observer = new IntersectionObserver(
        (entries) => {
          this.__callMethod("intersected", entries);
        },
        {
          ...defaultOptions,
          ...this.$options.intersectionObserver
        }
      );
      this.$on("mounted", () => {
        this.$observer.observe(this.$el);
      });
      this.$on("destroyed", () => {
        this.$observer.unobserve(this.$el);
      });
    }
  }
  return WithIntersectionObserver;
}
export {
  withIntersectionObserver
};
//# sourceMappingURL=withIntersectionObserver.js.map
